import React, { useRef, useState } from "react";
import { Button, ModalFooter } from "react-bootstrap";
import {
  processFiles,
  validateExcelExtension,
  validateHeaders,
} from "../../../../utils/File";
import uploadXlsxFile from "../../../../services/settings/uploadXlsxFile.service";
import { useToast } from "../../../../hooks";

const UploadXlsx = (props) => {
  const { title, processName, handleClose, expectedColumns } = props;
  const [files, setFiles] = useState(null);
  const addToast = useToast();
  const inputRef = useRef(null);
  const [isLoading, setLoading] = useState(false);

  const handleFiles = async (e) => {
    if (expectedColumns) {
      if (!validateExcelExtension(e.target.files[0])) {
        addToast({
          variant: "danger",
          header: title,
          body: "Formato incorrecto de archivo",
        });
        setFiles(null);
        inputRef.current.value = "";
        return;
      }

      try {
        await validateHeaders(e.target.files[0], expectedColumns);
      } catch (error) {
        addToast({
          variant: "danger",
          header: title,
          body: error.toString(),
        });
        setFiles(null);
        inputRef.current.value = "";
        return;
      }
      addToast({
        variant: "success",
        header: title,
        body: "Archivo valido y correcto",
      });
    }
    const newImages = await processFiles(e.target.files, processName);
    setFiles({
      images: [...newImages],
    });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await uploadXlsxFile.saveXlsxFile(files);
      if (response.status === 200 && response.data.success) {
        addToast({
          variant: "success",
          header: title,
          body: "Se ha subido el archivo con exito",
        });
      } else {
        addToast({
          variant: "danger",
          header: title,
          body: "Ha ocurrido un error",
        });
      }
      inputRef.current.value = "";
      setLoading(false);
      if (handleClose) {
        handleClose();
      }
    } catch (error) {
      console.error(error);
      inputRef.current.value = "";
      setLoading(false);
    }
  };

  return (
    <div style={{ marginBottom: "10px" }}>
      <div className="col">
        <label className="capitalize">
          <strong>{title}</strong>
        </label>
        <div>
          <span>
            <input
              type="file"
              accept=".xlsx"
              className="form-control"
              name="xlsx"
              encType="multipart/form-data"
              multiple={false}
              onChange={handleFiles}
              ref={inputRef}
            />
          </span>
        </div>
      </div>
      <div className="p-2">
        <ModalFooter>
          <Button
            className={`btn-fill pull-right btn btn-sm capitalize ${
              !isLoading ? "btn-info" : "btn-warning"
            }`}
            disabled={isLoading || !files?.images}
            onClick={!isLoading ? handleSubmit : null}
          >
            {isLoading ? "Procesando..." : "Guardar"}
          </Button>
        </ModalFooter>
      </div>
    </div>
  );
};

export default UploadXlsx;
